export default __webpack_public_path__ + "static/media/remove-gray.3187aeaa.svg";